(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function breadcrumb() {
    var breadcrumbList = $('.breadcrumb .breadcrumb-item');

    breadcrumbList.each(function (index, element) {
        var item = $(this);
        item.find("a").each(function () {
            $(this).addClass("link");
        });
    });
}

exports.breadcrumb = breadcrumb;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function campaignPage() {
    var blankEl = $('.blankCampaign');
    var hideMenu = $('.hideMenu');
    var primaryColor = $('.blankCampaign').attr('data-primarystyle');
    var secondaryColor = $('.blankCampaign').attr('data-secondarystyle');
    var campaignhomeColor = primaryColor || "#c8102e";

    if (blankEl) {
        $('.blankCampaign .hero .info-box').css('background-color', primaryColor);
        $('.blankCampaign .banner .info-box').css('background-color', primaryColor);
        $('.blankCampaign .hero .text-block').css('background-color', primaryColor);
        $('.seperator--green').css('border', '5px solid ' + secondaryColor);
        $('.footer .cookie').css('background-color', primaryColor);
        $('.accordion .card-header.collapsed').css('--iconcolor', primaryColor);
        $('.accordion .more').css('--iconcolor', primaryColor);
        $('.link.link-primary').css('border-bottom', '2px solid ' + primaryColor);
        $('.link.link-primary').css('--linkcolor', primaryColor);
        $('.page-menu .scroll-to-menu .item .link').css('color', primaryColor);
        $('.page-menu .call-to-action .item .link--call-to-action').css('color', primaryColor);
        $('.page-menu .btn-toggle').css('color', primaryColor);
        $('.page-menu .btn-toggle').css('--bordercolor', primaryColor);
        $('.page-menu .campaignmenu-item').css('color', primaryColor);
        $('.page-menu .campaignhometxt').css('color', primaryColor);
        $('.page-menu .campaignhometxt').css('--bordercolor', primaryColor);
        $('.page-menu .campaignhomelink').css('color', primaryColor);
    }

    if (hideMenu.length == 1) {
        $('.header').hide();
        $('.header').next().hide();
    } else {
        $('.header').show();
        $('.header').next().show();
    }

    $('#campaignMenu').on('show.bs.collapse', function () {
        $("button").removeClass("btn-default");
    });

    $('#campaignMenu').on('shown.bs.collapse', function (e) {
        var $clickedBtnId = $(e.target).parent().find('button').attr('id');

        $("#campaignhometxt").css("border-bottom", "none");

        if ($clickedBtnId != "campaignmenuDefaultButton") {
            $("#campaignmenuDefaultButton").css("border-bottom", "none");
        }

        $(".card-header-default").css('cssText', 'border-bottom: none !important');
    });

    $('#campaignMenu').on('hide.bs.collapse', function () {
        $("#campaignhometxt").css("border-bottom", "2px solid " + campaignhomeColor);
        $("#campaignmenuDefaultButton").css("border-bottom", "2px solid " + campaignhomeColor);
        $(".card-header-default").css('cssText', "border-bottom: 2px solid " + campaignhomeColor + " !important");
    });
}

exports.campaignPage = campaignPage;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function contentPage() {
    var blankEl = $('.blankContentPage');
    var hideMenu = $('.hideMenu');
    var primaryColor = $('.blankContentPage').attr('data-primarystyle');
    var secondaryColor = $('.blankContentPage').attr('data-secondarystyle');

    if (blankEl) {
        $('.blankContentPage .hero .info-box').css('background-color', primaryColor);
        $('.blankContentPage .banner .info-box').css('background-color', primaryColor);
        $('.blankContentPage .hero .text-block').css('background-color', primaryColor);
        $('.seperator--green').css('border', '5px solid ' + secondaryColor);
        $('.footer .cookie').css('background-color', primaryColor);
    }

    if (hideMenu.length == 1) {
        $('.header').hide();
        $('.header').next().hide();
    } else {
        $('.header').show();
        $('.header').next().show();
    }
}

exports.contentPage = contentPage;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Toggle cookie banner
 */
function toggleCookie() {
    $('.cookie-toggler').click(function () {
        $('#cookiebanner').show();
        $(this).css('left', '-70px');
    });
}

/**
 * Close options for selected group
 */
function closeBannerOptions() {
    var optionBox = $('.foll-out-box');
    $('.foll-out-box .icons-cookie-close').click(function () {
        optionBox.hide();
    });

    $('.foll-out-box .cookie-options-close').click(function () {
        optionBox.hide();
    });
}

/**
 * Open options for selected group
 */
function openBannerOptions() {
    $('#cookiebanner a[data-target]').click(function () {
        var target = $(this).attr('data-target');
        $('.' + target).show();
    });
}

/**
 *  Toggle a Cokkie slider in group 
 *  Toggle group checkbox
 *  Toggle only siders in the groups static and third party
 */
function checkGroupCookies() {
    if ($("input:checkbox[class='cookie otherCookie thirdpartyCookie']:checked")) {

        $(".cookie.otherCookie.thirdpartyCookie").on("click input", function () {

            if ($("input:checkbox[class='cookie otherCookie thirdpartyCookie']:checked").length >= 1) {
                $("input:checkbox[class='cookie otherCookie thirdpartyCookie']:checked").each(function () {
                    $("#thirdpartyCookie").prop("checked", true);
                });
            } else {
                $("#thirdpartyCookie").removeAttr("checked");
            }
        });
    }

    $("#thirdpartyCookie").change(function () {
        if (this.checked) {
            $(".cookie.otherCookie.thirdpartyCookie").each(function () {
                this.checked = true;
            });
        } else {
            $(".cookie.otherCookie.thirdpartyCookie").each(function () {
                this.checked = false;
            });
        }
    });

    $(".cookie.otherCookie.thirdpartyCookie").click(function () {
        if ($(this).is(":checked")) {
            var isAllChecked = 0;
            $(".cookie.otherCookie.thirdpartyCookie").each(function () {
                if (!this.checked) isAllChecked = 1;
            });
            if (isAllChecked == 0) {
                $("#thirdpartyCookie").prop("checked", true);
            }
        } else {
            $("#thirdpartyCookie").prop("checked", false);
        }
    });

    if ($("input:checkbox[class='cookie otherCookie statistics']:checked")) {

        $(".cookie.otherCookie.statistics").on("click input", function () {

            if ($("input:checkbox[class='cookie otherCookie statistics']:checked").length >= 1) {
                $("input:checkbox[class='cookie otherCookie statistics']:checked").each(function () {
                    $("#statistics").prop("checked", true);
                });
            } else {
                $("#statistics").removeAttr("checked");
            }
        });
    }

    $("#statistics").change(function () {
        if (this.checked) {
            $(".cookie.otherCookie.statistics").each(function () {
                this.checked = true;
            });
        } else {
            $(".cookie.otherCookie.statistics").each(function () {
                this.checked = false;
            });
        }
    });

    $(".cookie.otherCookie.statistics").click(function () {
        if ($(this).is(":checked")) {
            var isAllChecked = 0;
            $(".cookie.otherCookie.statistics").each(function () {
                if (!this.checked) isAllChecked = 1;
            });
            if (isAllChecked == 0) {
                $("#statistics").prop("checked", true);
            }
        } else {
            $("#statistics").prop("checked", false);
        }
    });
}

/**
 * Set a cookie, takes 3 paramters:
 * @param {string} cname 
 * @param {string} cvalue 
 * @param {int} exdays 
 */
function setCookie(cname, cvalue, exdays) {
    var date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toGMTString();
    if (cname != null || cname != undefined) {
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;" + "secure;" + "SameSite=Lax";
    }
}

/**
 * Hides cookie banner if a choice has been made by the user
 */
function cookieBannerValidation() {
    window.addEventListener('DOMContentLoaded', function () {
        var cookieBanner = getCookie("cookiebanner");
        if (cookieBanner !== "yes") {
            $("#cookiebanner").show();
            $("#readmoreaboutcookies").trigger("focus");
            $('.cookie-toggler').hide();
        }
    });
}

/**
 * Set checkbox to correct state depending on cookie value
 */
function cookieStartUpValidation() {
    $(document).ready(function () {
        var cookieList = getAllCookies();

        var acookie = getOneCookie("cookiebanner");
        $(".btn-cookie").click(function () {
            $(".cookie").prop("checked", true);
            $(".cookieGroup").prop("checked", true);
            setCookiesState("accept");
        });

        var _loop = function _loop(property) {
            var name = property;
            var value = cookieList[property];
            var checkboxGroup = $(":checkbox").filter(function () {
                return this.value == name;
            }).attr('id');
            var checkboxCookie = $(":checkbox").filter(function () {
                return this.value == name;
            });

            if (checkboxGroup != undefined && checkboxCookie.length != 0 && value == "yes") {
                {
                    if (checkboxCookie.length >= 0) {
                        checkkWithValue(name, "yes");
                        checkGroupValidation(checkboxGroup);
                    }
                }
            } else if (checkboxGroup != undefined && checkboxCookie != 0) {
                checkkWithValue(name, "false");
                checkGroupValidation(checkboxGroup);
                checkGroupCookies();
            }
        };

        for (var property in cookieList) {
            _loop(property);
        }
    });
}

function getOneCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}

function checkkWithValue(val, state) {
    if (state == "yes") {
        $(":checkbox").filter(function () {
            return this.value == val;
        }).prop("checked", true);
    } else {
        $(":checkbox").filter(function () {
            return this.value == val;
        }).prop("checked", false);
    }
}

/**
 * Check group validation
 */
function checkGroupValidation(cookiegroup) {
    var target = cookiegroup.replace(/\s+/g, "");
    var inputs = [];
    var inputsStates = [];

    inputs.push($('input[type=checkbox]#' + target));

    inputs.forEach(function (element) {
        element.each(function () {
            inputsStates.push($(this).prop('checked'));
        });
    });

    if (inputsStates.indexOf(false) > -1) {
        $('input[data-target=' + target + ']').prop('checked', false);
    } else {
        $('input[data-target=' + target + ']').prop('checked', true);
    }

    if (inputsStates.indexOf(false) >= 0) {
        $('input[data-target=' + target + ']').prop('checked', true);
    }

    if ($("input:checkbox[class='cookie otherCookie thirdpartyCookie']:checked").length >= 1) {
        $("input:checkbox[class='cookie otherCookie thirdpartyCookie']:checked").each(function () {
            $("#thirdpartyCookie").prop("checked", true);
        });
    } else {
        $("#thirdpartyCookie").removeAttr("checked");
    }

    if ($("input:checkbox[class='cookie otherCookie statistics']:checked").length >= 1) {
        $("input:checkbox[class='cookie otherCookie statistics']:checked").each(function () {
            $("#statistics").prop("checked", true);
        });
    } else {
        $("#statistics").removeAttr("checked");
    }
}

/**
 * Retrieve all cookies - returns array 
 */
function getAllCookies() {
    var cookies = {};

    if (document.cookie && document.cookie != '') {
        var split = document.cookie.split(';');
        for (var i = 0; i < split.length; i++) {
            var name_value = split[i].split("=");
            name_value[0] = name_value[0].replace(/^ /, '');
            cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
        }
    }

    return cookies;
}

/**
 * Get a cookie - returns value
 * @param {string} cname 
 */
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * Remove all cookies
 */
function removeCookies() {
    $(".btn-remove-cookies").click(function () {});
}

/**
 * Accept selected cookies and set cookiebanner cookie to true, so user will not se cookie banner again!
 */
function acceptCookies() {
    $(".btn-necessaryCookie").click(function () {
        $(".otherCookie.cookie").prop("checked", false);
        $(".otherCookie.cookieGroup").prop("checked", false);
        setCookiesState("accept");
    });

    $('.btn-accept-cookie').click(function () {
        setCookiesState("accept");
    });
}

/**
 * Helper function for setting cookie state
 * @param {*} choice 
 * @param {*} state 
 */
function setCookiesState(choice) {
    var cookieList = [];

    $('input[type=checkbox].cookie').each(function () {
        if ($(this).attr('id').startsWith('necessaryCookie')) {
            this.value = 'necessaryCookie';
            cookieList.push($(this));
        } else {
            cookieList.push($(this));
        }
    });
    $('input[type=checkbox].cookieGroup').each(function () {
        if ($(this).attr('data-target') == 'necessaryCookie') {
            this.value = 'necessaryCookie';
            cookieList.push($(this));
        } else {
            cookieList.push($(this));
        }
    });

    cookieList.forEach(function (element) {
        if (choice == "accept") {
            if (element[0].checked == true) {
                $(element).prop('checked', true);
                setCookie($(element).val(), "yes", 30);
            } else {
                $(element).prop('checked', false);
                setCookie($(element).val(), "", null, null);
            }
        } else if (choice == "remove") {
            $(element).prop('checked', true);
            setCookie($(element).val(), "", null, null);
        }
    });

    setCookie("cookiebanner", "yes", 30);
    $("#cookiebanner").hide();
    window.location.reload();
}

exports.toggleCookie = toggleCookie;
exports.closeBannerOptions = closeBannerOptions;
exports.openBannerOptions = openBannerOptions;
exports.checkGroupCookies = checkGroupCookies;
exports.cookieStartUpValidation = cookieStartUpValidation;
exports.setCookie = setCookie;
exports.removeCookies = removeCookies;
exports.acceptCookies = acceptCookies;
exports.cookieBannerValidation = cookieBannerValidation;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function editor() {
    $(document).ready(function () {
        var linksDiv = $('.editor').find('a.item');
        linksDiv.wrap('<div class="attachments"></div>');
    });
}

function usingMouse() {
    document.addEventListener("mousedown", function () {
        document.body.classList.add("using-mouse");
        document.body.classList.remove("using-keyboard");
    });

    document.addEventListener("keydown", function () {
        document.body.classList.add("using-keyboard");
        document.body.classList.remove("using-mouse");
    });
}
exports.editor = editor;
exports.usingMouse = usingMouse;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function facebookSharing() {
    $(function () {
        handleFBHeadTags();
    });
}

var handleFBHeadTags = function handleFBHeadTags() {
    //console.log('handleFBHeadTags!');

    var BodyChildren = $('body').children();

    var LookForImage = false;
    var ImageFound = false;
    var ImageSrc = '';

    $.each(BodyChildren, function (index, child) {
        var tagName = child.tagName;
        //console.log('tagName: ' + tagName);
        if (tagName !== undefined) {
            tagName = tagName.toLowerCase();
            LookForImage = !LookForImage && tagName === 'header' ? true : LookForImage && tagName === 'footer' ? false : true;

            if (!ImageFound && LookForImage && tagName !== 'header') {
                var Images = $(child).find('img');
                if (Images.length > 0) {
                    ImageFound = true;
                    var Image = Images[0];
                    ImageSrc = $(Image).attr('src');
                    //console.log('ImageSrc: ' + ImageSrc);
                }
            }
            if (ImageFound) return false;
        }
    });

    var Title = $('title').text();
    if (Title !== undefined) $('head').append('<meta property="og:title" content="' + Title + '">');
    var Description = $('meta[name="description"]');
    if (Description.length > 0) {
        $('head').append('<meta property="og:description" content="' + Description[0].getAttribute('content') + '">');
    }

    if (ImageFound) {
        $('head').append('<meta property="og:image" content="' + location.protocol + '//' + location.host + ImageSrc + '">');
    }
};
exports.facebookSharing = facebookSharing;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function factBox() {
    $(document).ready(function () {
        $('.map-box-group #accordion .btn').on('click', function (e) {
            var icon = $(this).find('icon-plus');
            var all_icons = $(this).closest('#accordion');
            all_icons.each(function () {
                $(this).find('.card .icon').removeClass('icon-minus').addClass('icon-plus');
            });
            icon.toggleClass('icon-plus icon-minus');
            e.preventDefault();
        });

        $('#factbox .btn').on('click', function (e) {
            var icon = $(this).find(".icon.plus");
            var all_icons = $(this).parents(".accordion");
            all_icons.each(function () {
                $(this).find(".card .icon").removeClass("minus").addClass("plus");
            });
            icon.toggleClass("plus minus");
            e.preventDefault();
        });
    });
}

exports.factBox = factBox;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fadeContent = undefined;

var _someFeed = require(".././components/some-feed.js");

function showHide() {
    if (!$("#fadeButton").is(":hidden")) {
        if ($("#fadeButton").is(":hidden")) {
            $(".attachments").show();
            $(".social-media").show();
            $(".content").show();
            $(".seperator--grey--30").show();
            $(".fb-root").show();
        } else {
            $(".attachments").hide();
            //$(".content").hide();
            $(".social-media").hide();
            $(".seperseperator--grey--30").hide();
            $(".fb-root").hide();
        }
    }
}

function fadeContent() {
    $(document).ready(function () {
        showHide($(this));
        $(window).on('load resize', function (e) {
            var _this = this;

            setTimeout(function () {
                showHide($(_this));
            }, 200);
            e.preventDefault();
        });

        $('#fadeButton').on('click', function (e) {
            $(this).hide();
            (0, _someFeed.startCheckCookie)();
            $(".content").show();
            $(".attachments").show();
            $(".social-media").show();
            $(".seperator--grey--30").show();
            $(".fb-root").show();
            $(".fade-content").animate({
                height: '100%'
            }, 500, function () {
                $(this).removeClass("fade-content");
            });
            e.preventDefault();
        });
    });
}

exports.fadeContent = fadeContent;

},{".././components/some-feed.js":17}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Wait for the element to exist in the dom
 * @param {*} selector 
 * @param {*} callback 
 */
var waitForEl = function waitForEl(selector, callback) {
    if (jQuery(selector).length) {
        callback();
    } else {
        setTimeout(function () {
            waitForEl(selector, callback);
        }, 10);
    }
};

function filterMenu() {
    $(function () {
        waitForEl(".filter-menu", function () {
            var selector = $('.filter-menu');

            $('#filterMenu').on('click', function () {
                $(selector).removeClass('MobileMenuClosed');
                $(selector).addClass('MobileMenuOpened');
                $("#filterMenuClose").trigger("focus");
                $("#filterMenuClose").trigger("select");

                $("#filterMenuClose").on("keydown", function (event) {
                    if (event.shiftKey && event.which === 9) {
                        $("#clearList").trigger("focus");
                    }
                });

                $("#clearList").on("keydown", function (event) {
                    if (!event.shiftKey && event.which === 9) {
                        $("#filterMenuClose").trigger("focus");
                    }
                });
            });

            $('#filterMenuClose').on('click', function () {
                $(selector).removeClass('MobileMenuOpened');
                $(selector).addClass('MobileMenuClosed');
                $('#filterMenu').trigger("focus");
            });
        });
    });

    // $("#filterMenu").on("click", function(){
    //     const selector = $('.filter-menu')
    //     $(selector).addClass('MobileMenuOpened');
    // })

    $(document).on('keydown', function (event) {
        if (event.key == "Escape") {
            var selector = $('.filter-menu');
            $(selector).removeClass('MobileMenuOpened');
            $(selector).addClass('MobileMenuClosed');
            $('#filterMenu').trigger("focus");
        }
    });

    // $(".MobileMenuOpened").click(function(){
    //     const selector = $('.filter-menu')
    //     $(selector).removeClass('MobileMenuOpened');
    //     $(selector).addClass('MobileMenuClosed');
    // })
}

exports.filterMenu = filterMenu;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function footer() {
    $(document).ready(function () {
        $(".footer .btn.btn-link").click(function () {
            $(this).toggleClass("expanded");
            var fa = $(this).find(".fa-minus");
            fa.removeClass('fa-minus').addClass('fa-plus');
        });
    });
}

function someLink() {
    $(document).ready(function () {
        var modalHeader = $('#someModal .modal-title');
        var modalBody = $('#someModal .modal-body');
        var modalSubmitBtn = $('#someModal .btn.btn-primary[type="submit"]');
        var link;

        $('.link.link-some').click(function () {
            link = $(this).attr('href');
            console.log($(this), link);
            modalSubmitBtn.click(function () {

                $('#someModal').modal('hide');
                window.open(link, '_blank');
                //window.location.href = link;
            });
        });
    });
}

exports.footer = footer;
exports.someLink = someLink;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function link() {
    $(".itemFeed").click(function () {
        window.location = $(this).find("a").attr("href");
        return false;
    });

    $(".iconLink").click(function () {
        window.location = $(this).find("a").attr("href");
        return false;
    });
}

exports.link = link;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Wait for the element to exist in the dom
 * @param {*} selector 
 * @param {*} callback 
 */
var waitForEl = function waitForEl(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

/**
 * Change the content an item in the list if element is from other auth
 */
function changeContent() {
  if ($(window).width() < 992) {
    waitForEl(".news-list", function () {
      var items = $(".news-list .list .item");
      items.each(function () {
        var seperator = $(this).find(".seperator:odd");
        var date = $(this).find(".date");
        if ($(this).find("a > .row > .col-12 > .info > .auth").length !== 0) {

          seperator.show();
          date.replaceWith(function () {
            return '<span class="date">' + $(this).html() + '</span>';
          });
        } else {
          seperator.hide();
          date.replaceWith(function () {
            return '<p class="date">' + $(this).html() + '</p>';
          });
        }
      });
    });
  } else {
    waitForEl(".news-list", function () {
      var items = $(".news-list .list .item");
      items.each(function () {
        var seperator = $(this).find(".seperator:odd");
        var date = $(this).find(".date");
        seperator.show();
        date.replaceWith(function () {
          return '<span class="date">' + $(this).html() + '</span>';
        });
      });
    });
  }
}

/**
 * Adapt content on window resize
 */
function newsListItems() {
  $(window).on("resize", function () {
    changeContent();
  });
}

/**
 * Toggle more subjects
 */
function subjectToggler() {
  waitForEl(".filter-menu", function () {
    var list = $('.filters .list');

    list.each(function () {
      var allItems = $(this).find('li').filter(function () {
        return $(this).children('input').length !== 0;
      });

      var allEmptyItems = $(this).find('li').filter(function () {
        return $(this).children('input').length == 0;
      });

      allEmptyItems.parent().next().hide();

      if (allItems.length > 5) {
        allItems.each(function (i, el) {
          if (i > 5) {
            el.hidden = true;
          }
        });
      } else {
        allItems.parent().next().hide();
      }
    });

    $('.load-more').click(function () {
      var closestItems = $(this).closest('div.filters').find('li');
      closestItems.each(function (i, el) {
        el.hidden = false;
      });
      $(this).hide();
    });
  });
}

exports.newsListItems = newsListItems;
exports.changeContent = changeContent;
exports.subjectToggler = subjectToggler;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.megaMenu = exports.disableWarningBanner = exports.searchInHeader = exports.promotedContentMobileMenu = exports.megaMenuToggle = exports.accordionIcons = exports.mobileMenuToggle = exports.sticky = undefined;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sticky() {
    var debounce = function debounce(fn) {
        var frame = void 0;
        return function () {
            for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                params[_key] = arguments[_key];
            }

            if (frame) {
                cancelAnimationFrame(frame);
            }
            frame = requestAnimationFrame(function () {
                fn.apply(undefined, params);
            });
        };
    };

    var storeScroll = function storeScroll() {
        document.documentElement.dataset.scroll = window.scrollY;
    };

    document.addEventListener('scroll', debounce(storeScroll), { passive: true });
    storeScroll();
}

function mobileMenuToggle() {
    $('[data-toggle="toggleMobileMenu"]').click(function () {
        var selector = $(this).data('target');
        $(selector).removeClass('navbarMobileMenuClosed');
        $(selector).addClass('navbarMobileMenuOpened');
    });
    $('.navbar-mobile-close').click(function () {
        var target = $(this).closest('#navbarMobile');
        target.removeClass('navbarMobileMenuOpened');
        target.addClass('navbarMobileMenuClosed');
    });
}

function promotedContentMobileMenu() {
    var target = $('.navbar-nav-mobile .accordion .card .related-content');
    target.find('.title').addClass('title--small');
    target.find('.icon').addClass('icon--small');
    target.find('.description').addClass('description--small');
}

function megaMenuToggle() {
    $('.nav-link').click(function () {
        var target = $(this).attr('href');
        if (!$(this).hasClass("nav-link--standalone")) {
            $('.navbar-nav .nav-item').each(function () {
                $(this).removeClass('active');
            });
            $('.mega-menu').collapse('hide');

            $(target).collapse('show');
            $(".content").show();

            return false;
        }
    });

    $(document).on('click', function () {
        var target = $('.mega-menu');
        if (target !== event.target && !target.has(event.target).length) {
            target.collapse('hide');
        }
    });
}

function accordionIcons() {

    $('.btn.btn-link.btn-menu').on('click', function (e) {
        var icon = $(this).find('icon-plus');
        var all_icons = $(this).closest('.accordion');
        all_icons.each(function () {
            $(this).find('.card .icon').removeClass('icon-minus').addClass('icon-plus');
        });
        icon.toggleClass('icon-plus icon-minus');
        e.preventDefault();
    });
}

/**
 * Toggle search functionality in header
 */
function searchInHeader() {
    var searchButton = $('.navbar-nav .nav-item .btn');
    searchButton.click(function () {
        if ($(this).hasClass("collapsed")) {
            //$(this).find('span').text('close');
            $(this).find('span').attr('data-icon', 'close');
            $(this).find('span').attr('aria-label', 'Luk');
        } else {
            //$(this).find('span').text('search');
            $(this).find('span').attr('data-icon', 'search');
            $(this).find('span').attr('aria-label', 'Søg');
        }
    });
}

function disableWarningBanner() {
    window.addEventListener('DOMContentLoaded', function () {
        var session = sessionStorage.getItem('disabledWarningBanner');
        if (session === "yes") {
            $('.warning-banner').animate({
                'height': '0px',
                'padding': '0px'
            }, "fast");
            $('.warning-banner').removeClass('d-block').addClass('d-none');
        }
    });

    $('.warning-banner .btn-disable').click(function () {
        sessionStorage.setItem('disabledWarningBanner', 'yes');
        $('.warning-banner').removeClass('d-block').addClass('d-none');
    });
}

$("#searchButton").click(function () {
    setTimeout(function () {
        $("#query").focus();
    }, 1000);
});

function megaMenu() {
    $(function () {
        $(".mega-menu").on("shown.bs.collapse", function () {
            $(this).find(".mega-menu-close-button").trigger("focus");
        });

        $(".mega-menu").each(function () {
            var lastmenulink = $(this).find(".mega-menu-link").last();

            $(lastmenulink).on("keydown", function (event) {
                if (!event.shiftKey && event.which === 9) {
                    $(".mega-menu").collapse('hide');
                    $('#navbarMobile').addClass('navbarMobileMenuClosed');
                }
            });
        });

        $("#navbarMobile").find(".link").last().on("keydown", function (event) {
            if (!event.shiftKey && event.which === 9) {
                $('#navbarMobile').addClass('navbarMobileMenuClosed');
                $('#navbarMobile').removeClass('navbarMobileMenuOpened');
            }
        });

        $(window).on("resize", function () {
            if ($(this).width() > 992) {
                var target = $('#navbarMobile');
                target.removeClass('navbarMobileMenuOpened');
                target.addClass('navbarMobileMenuClosed');
            }
        });
    });
}

exports.sticky = sticky;
exports.mobileMenuToggle = mobileMenuToggle;
exports.accordionIcons = accordionIcons;
exports.megaMenuToggle = megaMenuToggle;
exports.promotedContentMobileMenu = promotedContentMobileMenu;
exports.searchInHeader = searchInHeader;
exports.disableWarningBanner = disableWarningBanner;
exports.megaMenu = megaMenu;

},{"js-cookie":22}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function scrollToId() {
    $(document).ready(function () {
        $("a.link.scroll-to-id").click(function () {
            var target = $(this).attr("href");
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 500);
        });
    });
}

exports.scrollToId = scrollToId;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Scroll to top on reload
 */
function scrollToTop() {
    /* $(document).ready(function () {
        if (performance.navigation.type == 1) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        }
    }); */
}

exports.scrollToTop = scrollToTop;

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
//noiseBanner
function noiseBanner() {
    var closeWarningBanner = $('.noiseBanner .btn-close');
    var container = $('.noiseBanner').find('.container').last();
    var button = $(closeWarningBanner).find('.fa');

    /*    if (button.hasClass('fa-chevron-down')) {
           $('.noiseBanner').css('height', '50%');
           container.css('overflow', 'auto');
           container.css('height', '100%');
       }
        */
    $('#warningBanner').click(function () {
        if ($(this).find('span').hasClass('open')) {
            //$(this).find('span').text('keyboard_arrow_down');
            $(this).find('span').attr('data-icon', 'keyboard_arrow_down');
            $(this).find('span').addClass("close");
            $(this).find('span').removeClass("open");
        } else {
            //$(this).find('span').text('keyboard_arrow_up');
            $(this).find('span').attr('data-icon', 'keyboard_arrow_up');
            $(this).find('span').addClass("open");
            $(this).find('span').removeClass("close");
        }
    });

    closeWarningBanner.click(function () {
        var container = $(this).closest('.noiseBanner').find('.container').last();
        var icon = $(this).find('.fa');
        icon.toggleClass('fa-chevron-up fa-chevron-down');

        if (button.hasClass('fa-chevron-down')) {
            $('.noiseBanner').css('height', '50%');
            container.css('overflow', 'auto');
            container.css('height', '100%');
        }

        container.slideToggle();

        if (button.hasClass('fa-chevron-up')) {
            $('.noiseBanner').css('height', 'auto');
            container.css('overflow', 'auto');
            container.css('height', '100%');
        }
    });
}

function warningBanner() {
    var closeWarningBanner = $('.warning-banner .btn-close');

    closeWarningBanner.click(function () {
        var container = $(this).closest('.warning-banner').find('.container').first();
        var icon = $(this).find('.fa');
        icon.toggleClass('fa-chevron-up fa-chevron-down');
        container.slideToggle();
    });
}

exports.warningBanner = warningBanner;
exports.noiseBanner = noiseBanner;

},{}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Show cookie banner if clicked on btn
 */
function showCookieBanner() {
    $('body').on('click', '#showFacebookFeedBtn, #showTwitterFeedBtn, #showTwitterFeedBtn, #showMapsFeedBtn', function () {
        $('#cookiebanner').show();
        $('.cookie-toggler').css('left', '-60px');
    });
}

/**
 * Check if facebook or twitter cookie exist, if yes show feed
 */
function startCheckCookie() {
    $(document).ready(function () {
        var cookieList = getAllCookies();
        for (var property in cookieList) {
            var name = property;

            if (name.indexOf('facebook') > -1) {
                getFb(name);
            }

            if (name.indexOf('twitter') > -1) {
                getTwitter(name);
            }

            if (name.indexOf('google') > -1) {
                getGmaps(name);
            }

            if (name.indexOf("siteimprove") > -1) {
                setStatisticsCookieSettings(name);
            }
        }
    });
}

/**
 * Get siteimprove feed
 * @param {*} name 
 */

function setStatisticsCookieSettings(name) {
    var site = getOneCookie(name);
    if (site == "yes") {
        _require("https:////siteimproveanalytics.com/js/siteanalyze_273795.js", true);
    } else {}
}

/**
 * Get twitter feed
 * @param {*} name 
 */
function getTwitter(name) {
    var twitterCookie = getOneCookie(name);
    if (twitterCookie == "yes") {
        $(".twitter-root").show();
        $(".showTwitterFeed").hide();

        if (document.querySelector('.twitter-root') !== null) {
            if (!$(".twitter-root").is(":hidden")) {
                _require("https://platform.twitter.com/widgets.js", true);
            }
        }
    } else if (twitterCookie != "yes") {
        $(".twitter-root").hide();
        $(".showTwitterFeed").show();
    }
}

/**
 * Get facebook feed
 * @param {*} name 
 */
function getFb(name) {
    var fbCookie = getOneCookie(name);
    if (fbCookie == "yes") {
        $(".fb-root").show();
        $(".showFacebookFeed").hide();
        if (!$(".fb-root").is(":hidden")) {
            _require("https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v6.0", true);
        }
    } else if (fbCookie != "yes") {
        $(".fb-root").hide();
        $(".showFacebookFeed").show();
    }
}

/**
 * Get google maps
 * @param {*} name 
 */

function getGmaps(name) {
    var mapsCookie = getOneCookie(name);
    if (mapsCookie == "yes") {
        $(".maps-feed").show();
        $(".showMpas").hide();
        if (document.querySelector('.maps-feed') !== null) {
            if (!$(".maps-feed").is(":hidden")) {
                _require(loadMaps(), true);
            }
        }
    } else if (mapsCookie != "yes") {
        $(".maps-feed").hide();
        $(".showMpas").show();
    }
}

/**
 * Retrieve all cookies - returns array 
 */
function getAllCookies() {
    var cookies = {};

    if (document.cookie && document.cookie != '') {
        var split = document.cookie.split(';');
        for (var i = 0; i < split.length; i++) {
            var name_value = split[i].split("=");
            name_value[0] = name_value[0].replace(/^ /, '');
            cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
        }
    }
    return cookies;
}

/**
 * Get single cookie
 * @param {*} cname 
 */
function getOneCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {

            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * Sets scripts for feed
 * @param {*} file 
 * @param {*} callback 
 */
function _require(file, callback) {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement('script');
    script.src = file;
    script.type = 'text/javascript';
    //real browsers
    script.onload = callback;
    //Internet explorer
    script.onreadystatechange = function () {
        if (this.readyState == 'complete') {
            callback();
        }
    };
    head.appendChild(script);
}

exports.showCookieBanner = showCookieBanner;
exports.startCheckCookie = startCheckCookie;
exports.getFb = getFb;
exports.getTwitter = getTwitter;
exports.getGmaps = getGmaps;
exports.setStatisticsCookieSettings = setStatisticsCookieSettings;
exports.getOneCookie = getOneCookie;
exports.require = _require;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function tooltip() {
    //$('[data-toggle="tooltip"]').tooltip();
}

exports.default = tooltip;

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function twitterFeed() {
    $('.twitter-feed').delegate('#twitter-widget-0', 'DOMSubtreeModified propertychange', function () {
        customizeTweetMedia();
    });
}

var customizeTweetMedia = function customizeTweetMedia() {
    // CSS Overrides
    var container = $('.twitter-feed').find('.twitter-timeline');
    container.contents().find('.timeline-Tweet-brand').css('display', 'none');
    container.contents().find('.Icon--verified').css('display', 'none');

    if (window.matchMedia('(max-width: 720px)').matches) {
        container.contents().find('.timeline-Tweet').css('width', '100%');
        container.contents().find('.timeline-Tweet-retweetCredit').css('margin-left', '18px');
    } else if (window.matchMedia('(max-width: 1024px)').matches) {
        container.contents().find('.timeline-Tweet').css('width', '30%');
        container.contents().find('.timeline-Tweet-retweetCredit').css('margin-left', '18%');
    } else {
        container.contents().find('.timeline-Tweet').css('width', '31.4%');
        container.contents().find('.timeline-Tweet-retweetCredit').css('margin-left', '18%');
    }
    container.contents().find('.timeline-Tweet').css('float', 'left');
    container.contents().find('span.TweetAuthor-avatar.Identity-avatar').remove();
    container.contents().find('p.timeline-tweet-text').css('font-family', 'Verdana, Geneva, Tahoma, sans-serif');
    container.contents().find('p.timeline-Tweet-text').css('font-size', '17px');
    container.contents().find('p.timeline-tweet-text').css('line-height', '27px');
    container.contents().find('.timeline-Tweet-text').css('margin-top', '10px');
    container.contents().find('ul.timeline-tweet-actions').css('display', 'none');
    container.contents().find('.timeline-Tweet-author').css('width', '80%');
    container.contents().find('.timeline-Tweet-metadata').css('margin-right', '20px');
    container.contents().find('.timeline-Tweet-media').css('max-width', '80%');

    // Call the function on dynamic updates in addition to page load
    $('.twitter-feed').find('.twitter-timeline').contents().find('.timeline-TweetList').bind('DOMSubtreeModified propertychange', function () {
        customizeTweetMedia(this);
    });
};

exports.twitterFeed = twitterFeed;

},{}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function toggleView() {
    $('.toggle-view-btn').click(function (e) {
        var target = $(e.currentTarget);
        var map = target.closest('.options').next();
        var list = target.closest('.options').next().next();
        var popup = document.getElementById("myPopup");

        map.addClass('d-none');
        //popup.remove();
        $('.information-container').remove();
        //map.children().remove();
        list.addClass('d-block');
        //$('.content').removeAttr('style');
        target.remove();
    });
}

function initMap() {
    if (window.globesLoaded != undefined) {
        console.warn('Globes is already loaded!!!');
        return;
    }

    window.globesLoaded = 1;

    var globes = [];

    var plugins = {
        drag: function drag(options) {
            options = options || {};
            var noop = function noop() {};
            var onDragStart = options.onDragStart || noop;
            var onDragEnd = options.onDragEnd || noop;
            var onDrag = options.onDrag || noop;
            var afterDrag = options.afterDrag || noop;

            return function (planet) {
                planet.onInit(function () {
                    var drag = d3.behavior.drag().on('dragstart', onDragStart.bind(planet)).on('dragend', onDragEnd.bind(planet)).on('drag', function () {
                        onDrag.call(planet);
                        var dx = d3.event.dx;
                        var dy = d3.event.dy;
                        var rotation = planet.projection.rotate();
                        var radius = planet.projection.scale();
                        var scale = d3.scale.linear().domain([-1 * radius, radius]).range([-90, 90]);
                        var degX = scale(dx);
                        var degY = scale(dy);
                        rotation[0] += degX;
                        rotation[1] -= degY;
                        if (rotation[1] > 90) rotation[1] = 90;
                        if (rotation[1] < -90) rotation[1] = -90;
                        if (rotation[0] >= 180) rotation[0] -= 360;
                        planet.projection.rotate(rotation);
                        afterDrag.call(planet);
                    });
                    d3.select(planet.canvas).call(drag);
                });
            };
        },
        target: function target(speed, fade, zoomSpeed, zoomFade) {

            return function (planet) {

                var on = false;
                var lastTick = null;
                var target = [];
                var zoomTarget = undefined;

                planet.plugins.target = {
                    resume: function resume() {
                        on = true;
                    },
                    pause: function pause() {
                        on = false;
                    },
                    moveTo: function moveTo(newTarget, zoom) {
                        zoomTarget = zoom;target = newTarget;on = true;
                    }
                };

                planet.onDraw(function () {

                    if (!on || !lastTick) {
                        lastTick = new Date();
                    } else {

                        var now = new Date();
                        var delta = now - lastTick;
                        lastTick = now;

                        var rotation = planet.projection.rotate();

                        var distX = -target[0] - rotation[0];
                        distX += 180;
                        while (distX < 0) {
                            distX += 360;
                        }distX %= 360;
                        distX -= 180;

                        var distY = -target[1] - rotation[1];
                        distY += 180;
                        while (distY < 0) {
                            distY += 360;
                        }distY %= 360;
                        distY -= 180;

                        var dist = Math.sqrt(Math.pow(distX, 2) + Math.pow(distY, 2));

                        on = false;

                        if (dist > 0.1) {

                            on = true;

                            var deltaX = distX / dist * delta * speed / 1000;
                            deltaX *= sigmoid(dist / fade);
                            if (Math.abs(deltaX) > Math.abs(distX)) deltaX = distX;

                            var deltaY = distY / dist * delta * speed / 1000;
                            deltaY *= sigmoid(dist / fade);
                            if (Math.abs(deltaY) > Math.abs(distY)) deltaY = distY;

                            if (!isNaN(deltaX)) rotation[0] += deltaX;
                            if (!isNaN(deltaY)) rotation[1] += deltaY;

                            planet.projection.rotate(rotation);
                        }

                        if (zoomTarget != undefined) {

                            var currentZoom = planet.scaleFactor / planet.projection.scale();
                            var zoomDist = zoomTarget - currentZoom;

                            if (Math.abs(zoomDist) > 0.01) {

                                on = true;

                                var zoomDelta = zoomDist * delta * zoomSpeed / 1000;
                                zoomDelta *= sigmoid(Math.abs(zoomDist) / zoomFade);

                                if (Math.abs(zoomDelta) > Math.abs(zoomDist)) zoomDelta = zoomDist;

                                planet.projection.scale(planet.scaleFactor / (currentZoom + zoomDelta));
                                planet.zoom.scale(planet.projection.scale());
                                updatePings(planet);
                            }
                        }
                    }
                });
            };
        },

        ping: function ping(color, activeColor, angle, frequency) {

            var drawPings = function drawPings(planet, context) {

                var scale = planet.projection.scale() / planet.scaleFactor;

                for (var i = 0; i < planet.pings.length; i++) {
                    drawPing(planet, context, planet.pings[i]);
                }
            };

            var drawPing = function drawPing(planet, context, target) {

                context.fillStyle = target.selected == true ? activeColor : color;

                var size = target.size || angle;

                var circle = d3.geo.circle().origin(target.pos).angle(size * planet.scaleFactor * (target.selected ? Math.sin(new Date() * Math.PI * frequency / 500) / 2 + 0.5 : 1) / planet.projection.scale())();

                context.beginPath();
                planet.path.context(context)(circle);
                context.fill();

                var screenPos = getScreenPos(planet, target.pos);
                if (screenPos) {

                    context.strokeStyle = context.fillStyle;

                    context.beginPath();
                    context.moveTo(screenPos[0], screenPos[1]);
                    context.lineTo(screenPos[0], screenPos[1] + (target.label == "under" ? 27 : -27));
                    context.lineTo(screenPos[0] + 5, screenPos[1] + (target.label == "under" ? 27 : -27));
                    context.stroke();

                    context.font = "20px Arial";
                    context.fillText(target.navn, screenPos[0] + 10, screenPos[1] + (target.label == "under" ? 33 : -20));
                }
            };

            return function (planet) {
                planet.targets = [];

                planet.onDraw(function () {
                    planet.withSavedContext(function (context) {

                        context.lineWidth = 2;
                        drawPings(planet, context);
                    });
                });
            };
        },

        zoom: function zoom(options) {
            options = options || {};
            var noop = function noop() {};
            var onZoomStart = options.onZoomStart || noop;
            var onZoomEnd = options.onZoomEnd || noop;
            var onZoom = options.onZoom || noop;
            var afterZoom = options.afterZoom || noop;
            var startScale = options.initialScale;
            var scaleExtent = options.scaleExtent || [50, 2000];

            return function (planet) {
                planet.onInit(function () {

                    var zoom = d3.behavior.zoom().scaleExtent(scaleExtent);

                    if (startScale !== null && startScale !== undefined) {
                        zoom.scale(startScale);
                    } else {
                        zoom.scale(planet.projection.scale());
                    }

                    zoom.on('zoomstart', onZoomStart.bind(planet)).on('zoomend', onZoomEnd.bind(planet)).on('zoom', function () {
                        onZoom.call(planet);
                        planet.projection.scale(d3.event.scale);
                        afterZoom.call(planet);
                    });
                    d3.select(planet.canvas).call(zoom);

                    planet.zoom = zoom;
                });
            };
        }

    };

    $(document).ready(function () {

        $('canvas[globe]').each(function () {
            var _this = this;

            $(this).css('-webkit-tap-highlight-color', '#0000');
            $(this).css('touch-action', 'manipulation');

            var globe = planetaryjs.planet();

            globe.id = $(this).attr('globe');
            if (typeof globe.id != 'number') {
                globe.id = globes.length;
            }
            globes[globe.id] = globe;
            $(this).attr('globe', globe.id);

            loadPlugins(globe, this);

            resize(this, globe);

            setInterval(function () {
                resize(_this, globe);
            }, 500);

            $(window).resize(function () {
                resize(_this, globe);
            });

            globe.projection.scale(globe.scaleFactor / globe.startZoom).rotate([-globe.startPos[0], -globe.startPos[1]]);

            this.addEventListener("touchmove", function (e) {
                e.preventDefault();
            }, { passive: false });

            globe.onInit(function () {

                if ($(_this).attr('targets') != undefined) {
                    var reversePos = function reversePos(targets) {
                        for (var i = 0; i < targets.length; i++) {
                            var tmp = targets[i].pos[0];
                            targets[i].pos[0] = targets[i].pos[1];
                            targets[i].pos[1] = tmp;

                            if (targets[i].operationer) {

                                if (targets[i].operationer.length > 1) {
                                    var globeref = targets[i].navn;
                                    var targetid = String(targets[i].navn).replace(/\s/g, '');
                                    $('.world-map').append('<div class="map-box-group" id="' + targetid + '" globe-ref="' + targets[i].navn + '"></div>');
                                    $('#' + targetid).append(' <span class="material-icons-outlined icons-maps-close col-12" data-icon="close"></span><div id="accordion' + targetid + '" class="col-12 accordion"></div>');

                                    targets[i].operationer.forEach(function (element, index) {

                                        $('#' + targetid + ' #accordion' + targetid).append('<div class="card">' + '<div class="card-header" id="heading' + targetid + index + '">' + '<div class="card-title titel mb-0">' + '<button class="btn btn-link collapsed" data-toggle="collapse" data-target="#item' + targetid + index + '" aria-expanded="true" aria-controls=' + index + '>' + '<span class="text">' + element.titel + '</span>' + '<span class="icon icon-plus more material-icons-outlined"></span>' + '</button>' + '</div>' + '</div>' + '<div id="item' + targetid + index + '" class="collapse" aria-labelledby="headingOne" data-parent="#accordion' + targetid + '">' + '<div class="card-body">' + element.beskrivelse + '<p><a class="link" href=' + element.link + ' target="_blank" alt="Link to operation">Link to operation</a></p>' + '</div>' + '</div>' + '</div>');
                                    });
                                } else {
                                    targets[i].operationer.forEach(function (element) {
                                        $('.world-map').append('<div class="map-box" globe-ref="' + targets[i].navn + '">' + '<div class="header">' + '<h2>' + element.titel + '</h2>' + '<span class="material-icons-outlined icons-maps-close" data-icon="close"></span>' + '</div>' + '<p class="description">' + element.beskrivelse + '</p>' + '<a class="link" href=' + element.link + ' target="_blank" alt="Link til operation">Link til operation</a>' + '</div>');
                                    });
                                }
                            }

                            if (targets[i].sub instanceof Array) {
                                reversePos(targets[i].sub);
                            }
                        }
                    };

                    globe.targets = JSON.parse($(_this).attr('targets'));

                    reversePos(globe.targets);
                }

                updatePings(globe);
            });

            globe.draw(this);
        });

        $('[globe-link]').click(function (e) {

            var arg = $(e.currentTarget).attr('globe-link');
            arg = arg.split(',');
            moveToTarget(globes[arg[0]], arg[1]);
        });

        $('.world-map .icons-maps-close').click(function (e) {
            var target = $(e.currentTarget);
            target.closest('.map-box-group').hide();
            target.closest('.map-box').hide();
        });

        $('[globe-ref]').css('display', 'none');
    });

    function resize(canvas, globe) {

        if (canvas.width == $(canvas).width() && canvas.height == $(canvas).height()) return;

        canvas.width = $(canvas).width();
        canvas.height = $(canvas).height();

        var oldScaleFactor = globe.scaleFactor;

        globe.scaleFactor = Math.min(canvas.width, canvas.height);

        globe.projection.scale(globe.projection.scale() * globe.scaleFactor / oldScaleFactor).translate([canvas.width / 2, canvas.height / 2]);
    }

    function sigmoid(t) {
        return 2 / (1 + Math.pow(Math.E, -t)) - 1;
    }

    function getMousePos(canvas, evt) {
        var rect = canvas.getBoundingClientRect();
        return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
        };
    }

    function onTouch(e) {

        var globe = globes[$(e.target).attr('globe')];

        if (!globe.clicked) return;

        if (globe.dragging) {
            globe.dragging = false;
            return;
        }

        var pos = getMousePos(this, e);

        var coordinates = getCoordinates(pos, globe);

        var closest = findClosestTarget(globe, coordinates);

        if (typeof closest.zoom == 'number') {
            globe.plugins.target.moveTo(closest.pos, closest.zoom);
        } else {
            globe.plugins.target.moveTo(closest.pos);
        }

        displayText(globe, closest);
    }

    function displayText(globe, target) {

        if (target == undefined) {
            $('[globe-ref]').css('display', 'none');
            $('[globe-default=' + globe.id + ']').css('display', '');
            return;
        }

        var display = $('[globe-ref="' + target.navn + '"]');

        if (display.length > 0) {
            $('[globe-ref],[globe-default=' + globe.id + ']').css('display', 'none');
            display.css('display', '');
        }
    }

    function selectByPos(globe) {

        var coordinates = getCoordinates(globe.mousePos, globe);
        if (coordinates == undefined) {
            return;
        }

        select(globe, findClosestTarget(globe, coordinates));
    }

    function onMove(e) {
        var globe = globes[$(e.target).attr('globe')];

        globe.mousePos = getMousePos(this, e);
        selectByPos(globe);
    }

    function getCoordinates(pos, globe) {

        pos = JSON.parse(JSON.stringify(pos));

        var globePos = globe.projection.translate();
        var globeScale = globe.projection.scale();

        pos.x -= globePos[0];
        pos.y = globePos[1] - pos.y;

        pos.x /= globeScale;
        pos.y /= globeScale;

        var distToCenter = Math.sqrt(Math.pow(pos.x, 2) + Math.pow(pos.y, 2));

        if (distToCenter > 1) {
            return;
        }

        var rot = globe.projection.rotate();

        pos.z = Math.sqrt(1 - Math.pow(pos.x, 2) - Math.pow(pos.y, 2));

        var rotY = rot[0] * Math.PI / 180;
        var rotX = -rot[1] * Math.PI / 180;

        pos.tz = pos.z * Math.cos(rotX) - pos.y * Math.sin(rotX);
        pos.y = pos.z * Math.sin(rotX) + pos.y * Math.cos(rotX);
        pos.z = pos.tz;

        pos.tx = pos.x * Math.cos(rotY) - pos.z * Math.sin(rotY);
        pos.z = pos.x * Math.sin(rotY) + pos.z * Math.cos(rotY);
        pos.x = pos.tx;

        var lng = Math.atan2(pos.x, pos.z) * 180 / Math.PI;
        var lat = Math.asin(pos.y) * 180 / Math.PI;

        return [lng, lat];
    }

    function getScreenPos(globe, pos) {

        if (pos == undefined) return false;

        pos = JSON.parse(JSON.stringify(pos));

        pos[0] = (90 - pos[0]) * Math.PI / 180;
        pos[1] = pos[1] * Math.PI / 180;

        var rad = Math.cos(pos[1]);

        var pos3d = {
            x: rad * Math.cos(pos[0]),
            y: Math.sin(pos[1]),
            z: rad * Math.sin(pos[0])
        };

        var rot = globe.projection.rotate();

        var rotY = -rot[0] * Math.PI / 180;
        var rotX = rot[1] * Math.PI / 180;

        pos3d.tx = pos3d.x * Math.cos(rotY) - pos3d.z * Math.sin(rotY);
        pos3d.z = pos3d.x * Math.sin(rotY) + pos3d.z * Math.cos(rotY);
        pos3d.x = pos3d.tx;

        pos3d.tz = pos3d.z * Math.cos(rotX) - pos3d.y * Math.sin(rotX);
        pos3d.y = pos3d.z * Math.sin(rotX) + pos3d.y * Math.cos(rotX);
        pos3d.z = pos3d.tz;

        if (pos3d.z < 0) return false;

        var scale = globe.projection.scale();
        pos3d.x *= scale;
        pos3d.y *= scale;

        var translation = globe.projection.translate();
        pos3d.x += translation[0];
        pos3d.y = translation[1] - pos3d.y;

        return [pos3d.x, pos3d.y];
    }

    function loadPlugins(globe, canvas) {

        var leapSpeed = $(canvas).attr('leap-speed') || 200;
        var leapFade = $(canvas).attr('leap-fade') || 20;

        var map = $(canvas).attr('map') || 'world-110m.json';

        // Colors
        var colors = {
            ocean: $(canvas).attr('ocean-color') || '#000',
            land: $(canvas).attr('land-color') || '#666',
            border: $(canvas).attr('border-color') || '#000',
            ping: $(canvas).attr('ping-color') || '#c8102e',
            activePing: $(canvas).attr('active-ping-color') || '#8d1b3d'
        };
        var pingSize = $(canvas).attr('ping-size') || 1;
        var pingFrequency = $(canvas).attr('ping-frequency') || 1.5;

        var zoomFade = $(canvas).attr('zoom-fade') || 0.05;
        var zoomSpeed = $(canvas).attr('zoom-speed') || 5;

        globe.startPos = JSON.parse($(canvas).attr('start-pos') || "[0,0]");
        globe.startPos = [globe.startPos[1], globe.startPos[0]];
        globe.startZoom = $(canvas).attr('start-zoom') || 2;

        globe.zoomMin = $(canvas).attr('zoom-min') || 300;
        globe.zoomMax = $(canvas).attr('zoom-max') || 3000;

        globe.dragResistance = $(canvas).attr('drag-resistance') || 0.07;

        globe.loadPlugin(planetaryjs.plugins.earth({
            topojson: { file: map },
            oceans: { fill: colors.ocean },
            land: { fill: colors.land, stroke: colors.border },
            borders: { stroke: colors.border }
        }));

        globe.loadPlugin(plugins.ping(colors.ping, colors.activePing, pingSize, pingFrequency));

        globe.loadPlugin(plugins.target(leapSpeed, leapFade, zoomSpeed, zoomFade));

        globe.loadPlugin(plugins.zoom({
            scaleExtent: [globe.zoomMin, globe.zoomMax],
            onZoomStart: function onZoomStart() {
                globe.plugins.target.pause();
            },
            afterZoom: function afterZoom() {
                updatePings(globe);
            }
        }));

        globe.dragging = false;
        globe.dontSpin = false;

        globe.loadPlugin(plugins.drag({
            onDragStart: function onDragStart() {
                globe.plugins.target.pause();
                globe.dontSpin = true;
                globe.clicked = false;
            },
            onDrag: function onDrag() {
                globe.speed = [d3.event.dx, d3.event.dy];
                globe.dragging = true;
            },
            onDragEnd: function onDragEnd() {

                if (!globe.dragging) {
                    globe.clicked = true;
                } else {
                    globe.dragging = false;
                }

                globe.dontSpin = false;
            }
        }));

        var lastTick;

        spin(globe);

        $(canvas).on('click', onTouch);
        $(canvas).on('mousemove', onMove);
    }

    function spin(globe) {

        globe.onDraw(function () {

            if (globe.speed != undefined && !globe.dontSpin) {

                var rotation = globe.projection.rotate();
                var radius = globe.projection.scale();
                var scale = d3.scale.linear().domain([-1 * radius, radius]).range([-90, 90]);
                var degX = scale(globe.speed[0]);
                var degY = scale(globe.speed[1]);
                globe.speed[0] *= 1 - globe.dragResistance;
                globe.speed[1] *= 1 - globe.dragResistance;
                rotation[0] += degX;
                rotation[1] -= degY;
                if (rotation[1] > 90) rotation[1] = 90;
                if (rotation[1] < -90) rotation[1] = -90;
                if (rotation[0] >= 180) rotation[0] -= 360;
                globe.projection.rotate(rotation);
            }
        });
    }

    function updatePings(globe) {

        globe.pings = [];

        if (!(globe.targets instanceof Array)) {
            return;
        }

        var scale = globe.scaleFactor / globe.projection.scale();

        function pingRecurse(targets) {

            for (var i = 0; i < targets.length; i++) {

                if (typeof targets[i].zoom == 'number' && targets[i].sub instanceof Array && scale <= targets[i].zoom + 0.1) {
                    pingRecurse(targets[i].sub);
                } else {
                    globe.pings.push(targets[i]);
                }
            }
        }
        pingRecurse(globe.targets);

        if (globe.mousePos != undefined) selectByPos(globe);
    }

    function findClosestTarget(globe, coordinates) {

        var rot = globe.projection.rotate();
        var closestDist = 10000000;
        var closest = {};

        for (var i = 0; i < globe.pings.length; i++) {
            var distLng = coordinates[0] - globe.pings[i].pos[0];
            var distLat = coordinates[1] - globe.pings[i].pos[1];
            var dist = Math.sqrt(distLng * distLng + distLat * distLat);
            if (closestDist > dist) {
                closestDist = dist;
                closest = globe.pings[i];
            }
        }

        return closest;
    }

    function select(globe, target) {
        if (globe.selected != undefined) {
            globe.selected.selected = false;
        }
        globe.selected = target;
        target.selected = true;
    }

    function moveToTarget(globe, name) {

        if (name == undefined) {
            globe.plugins.target.moveTo(globe.startPos, globe.startZoom);
            displayText(globe);
            return;
        }

        function findTargetRec(targets) {
            for (var i = 0; i < targets.length; i++) {

                if (targets[i].navn == name) return targets[i];

                if (targets[i].sub instanceof Array) {
                    var res = findTargetRec(targets[i].sub);
                    if (res !== false) {
                        return res;
                    }
                }
            }

            return false;
        }

        var target = findTargetRec(globe.targets);

        if (target === false) {
            console.warn('could not find country ' + name);
            return;
        }

        globe.plugins.target.moveTo(target.pos, target.zoom);
        select(globe, target);
        displayText(globe, target);
    }
}

exports.initMap = initMap;
exports.toggleView = toggleView;

},{}],21:[function(require,module,exports){
"use strict";

var _factbox = require("./components/factbox");

var _fadeContent = require("./components/fade-content");

var _filterMenu = require("./components/filter-menu");

var _scrollToTop = require("./components/scrollToTop");

var _menu = require("./components/menu");

var _scrollToId = require("./components/scrollToId");

var _footer = require("./components/footer");

var _list = require("./components/list");

var _cookies = require("./components/cookies");

var _breadcrumb = require("./components/breadcrumb");

var _campaignPage = require("./components/campaignPage");

var _contentPage = require("./components/contentPage");

var _worldMap = require("./components/world-map");

var _someFeed = require("./components/some-feed.js");

var _editor = require("./components/editor");

var _tooltip = require("./components/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _twitter = require("./components/twitter");

var _showHide = require("./components/showHide");

var _facebookSharing = require("./components/facebookSharing");

var _links = require("./components/links");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _worldMap.initMap)();
(0, _factbox.factBox)();
(0, _fadeContent.fadeContent)();
(0, _filterMenu.filterMenu)();
(0, _scrollToTop.scrollToTop)();
(0, _menu.sticky)();
(0, _menu.mobileMenuToggle)();
(0, _menu.searchInHeader)();
(0, _menu.promotedContentMobileMenu)();
(0, _menu.megaMenuToggle)();
(0, _menu.accordionIcons)();
(0, _scrollToId.scrollToId)();
(0, _footer.footer)();
(0, _breadcrumb.breadcrumb)();
(0, _list.newsListItems)();
(0, _list.changeContent)();
//subjectToggler();
(0, _editor.editor)();
(0, _editor.usingMouse)();
(0, _someFeed.startCheckCookie)();
(0, _someFeed.showCookieBanner)();
(0, _someFeed.getFb)();
(0, _someFeed.getTwitter)();
(0, _someFeed.getGmaps)();
(0, _someFeed.setStatisticsCookieSettings)();
(0, _someFeed.getOneCookie)();
(0, _cookies.toggleCookie)();
(0, _cookies.closeBannerOptions)();
(0, _cookies.openBannerOptions)();
(0, _cookies.checkGroupCookies)();
(0, _cookies.cookieStartUpValidation)();
(0, _cookies.acceptCookies)();
(0, _cookies.cookieBannerValidation)();
(0, _cookies.setCookie)();
(0, _cookies.removeCookies)();
(0, _footer.someLink)();
(0, _campaignPage.campaignPage)();
(0, _contentPage.contentPage)();
(0, _worldMap.toggleView)();
(0, _tooltip2.default)();
(0, _showHide.warningBanner)();
(0, _twitter.twitterFeed)();
(0, _showHide.noiseBanner)();
(0, _twitter.twitterFeed)();
(0, _menu.disableWarningBanner)();
(0, _facebookSharing.facebookSharing)();
(0, _links.link)();
(0, _menu.megaMenu)();

},{"./components/breadcrumb":1,"./components/campaignPage":2,"./components/contentPage":3,"./components/cookies":4,"./components/editor":5,"./components/facebookSharing":6,"./components/factbox":7,"./components/fade-content":8,"./components/filter-menu":9,"./components/footer":10,"./components/links":11,"./components/list":12,"./components/menu":13,"./components/scrollToId":14,"./components/scrollToTop":15,"./components/showHide":16,"./components/some-feed.js":17,"./components/tooltip":18,"./components/twitter":19,"./components/world-map":20}],22:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}]},{},[21]);
